/* Marquee countdown. Logic copied from the mock (04-SOURCE-HTML/01-hero-through-s2): seconds to midnight America/New_York,
   recomputed every second, every pill ticks together. Modes: daily | fixed (Theme settings > countdown end) | off. */
(() => {
  if (window.SM && window.SM.countdownStarted) return;
  window.SM = window.SM || {};
  window.SM.countdownStarted = true;
  const cfg = (window.SM.config && window.SM.config.countdown) || { mode: 'daily', timeZone: 'America/New_York' };
  if (cfg.mode === 'off') return;

  function remToMidnight(tz) {
    const parts = Object.fromEntries(
      new Intl.DateTimeFormat('en-US', { timeZone: tz, hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false })
        .formatToParts(new Date()).map((p) => [p.type, p.value])
    );
    const h = parts.hour === '24' ? 0 : +parts.hour;
    return 24 * 3600 - (h * 3600 + +parts.minute * 60 + +parts.second);
  }
  const endMs = cfg.mode === 'fixed' && cfg.end ? Date.parse(cfg.end) : NaN;
  function remaining() {
    if (cfg.mode === 'fixed') {
      if (isNaN(endMs)) return -1;
      return Math.floor((endMs - Date.now()) / 1000);
    }
    return remToMidnight(cfg.timeZone || 'America/New_York');
  }
  const pad = (n) => String(n).padStart(2, '0');
  let timer;
  function tick() {
    const rem = remaining();
    const bars = document.querySelectorAll('[data-sm-marquee]');
    if (rem <= 0) {
      bars.forEach((b) => b.classList.add('is-expired'));
      clearInterval(timer);
      return;
    }
    const hh = pad(Math.floor(rem / 3600)), mm = pad(Math.floor((rem % 3600) / 60)), ss = pad(rem % 60);
    document.querySelectorAll('[data-sm-countdown]').forEach((p) => {
      const h = p.querySelector('[data-h]'), m = p.querySelector('[data-m]'), s = p.querySelector('[data-s]');
      if (h.textContent !== hh) h.textContent = hh;
      if (m.textContent !== mm) m.textContent = mm;
      s.textContent = ss;
    });
  }
  tick();
  timer = setInterval(tick, 1000);
})();
